export const cleartDraft = () => {
  const selectedProduct = localStorage.getItem('selectedProduct');

  if (selectedProduct !== null) {
    localStorage.removeItem(selectedProduct);
  }

  return;
};
